import { ComponentsPlatformService } from '@wix/editor-platform-manifest-services';
import { CompRef } from '@wix/document-services-types';
import {
  hasAnyMeaningfulValue,
  isAllowedStylePresent,
} from '../common/actionValidators/actionVisibilityRules';
import { Meaningfulness } from '../common/meaningfulnessPredicates';
import { getAllowedPropertiesForAction } from '../constants';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';

import { EditorPointer } from '@wix/editor-document-logic-api';

/**
 * Corner action validator
 *
 * Rules:
 * - Show if any element has corner radius property (including 0px)
 * - 0px is meaningful for corners (explicit sharp corner)
 * - Show if root has corner radius property in manifest
 *
 * @param componentsAPI - Components platform service
 * @param editorPointers - Selected editor pointers
 * @returns true if corner action should be shown
 */
export const createCornerValidator = () => {
  return (
    componentsAPI: ComponentsPlatformService,
    editorPointers: EditorPointer<CompRef>[],
  ): boolean => {
    const rootContexts = editorPointers.map((editorPointer) =>
      componentsAPI.buildManifestAPI({ editorPointers: [editorPointer] }),
    );

    const cornerProperties = new Set(
      getAllowedPropertiesForAction(StylesDerivedNativeActions.cornerStyles),
    );

    for (const rootContext of rootContexts) {
      if (
        isAllowedStylePresent(rootContext, cornerProperties) ||
        hasAnyMeaningfulValue(
          rootContext,
          cornerProperties,
          Meaningfulness.meaningCheck(StylesDerivedNativeActions.cornerStyles), // Corner rule: both 0 and non-zero are meaningful
        )
      ) {
        return true;
      }
    }

    return false;
  };
};
